import { MenuItemLink } from 'react-admin';
import { styled } from '@mui/material/styles';
import { TURN_STYLES } from '@/styles/theme';

export const Wrapper = styled('div')<{ show: boolean }>(({ theme, show }) => ({
  marginTop: '10px',
  padding: '0 8px',
  color: TURN_STYLES.primaryColor,

  opacity: show ? 1 : 0,
  visibility: show ? 'visible' : 'hidden',
  transition: 'opacity 0.3s ease, visibility 0.3s ease',

  '& .MuiMenuItem-root': {
    margin: '8px 0',
    width: '220px',
    height: '48px',
    borderRadius: '8px',
    fontSize: '14px',
    transition: 'all 0.3s ease',
  },

  '& .MuiMenuItem-root .MuiSvgIcon-root': {
    color: TURN_STYLES.primaryColor,
  },

  '& .MuiMenuItem-root:hover, & .MuiMenuItem-root.RaMenuItemLink-active:not(#back-to-mordor)': {
    color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : 'white',
    backgroundColor: TURN_STYLES.primaryAccentColor,

    '& .MuiSvgIcon-root': {
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : 'white',
    },
  },
}));
